<n-slide-window
    [width]="(!isEn || isSimpleMode) ? '8.96rem' : '9.5rem'"
    [visible]="windowVisible"
    (onHide)="close()">
    <n-header>
        <h1>
            {{i18n.title.createTitle}}
            <n-help-link [key]="type === ScheduleTypeE.Block ? 'hypercdpplanCreate' : 'fshypercdpplanCreate'"
                *ngIf="!isSimpleMode"></n-help-link>
            <n-help-link [key]="'simplifyspCreate'" *ngIf="isSimpleMode"></n-help-link>
        </h1>
        <div></div>
        <!-- 步骤条，仅标准模式使用 -->
        <n-steps
            *ngIf="!isSimpleMode"
            id="create_hyperCDP_schedule_steps_id"
            [model]="steps"
            [activeIndex]="activeIndex"
            styleClass="steps"
            [showStatus]="true">
        </n-steps>
    </n-header>

    <!-- 标准模式场景，使用tab步骤条控制的tab -->
    <n-tab *ngIf="!isSimpleMode" [hideHeader]="true"
        [(activeIndex)]="activeIndex"
        #tab>
        <n-tab-item>
            <ng-template nTemplate>
                <ng-container [ngTemplateOutlet]="specifyObjTemplate">
                </ng-container>
            </ng-template>
        </n-tab-item>
        <n-tab-item>
            <ng-template nTemplate>
                <ng-container [ngTemplateOutlet]="configPolicyTemplate">
                </ng-container>
            </ng-template>
        </n-tab-item>
        <n-tab-item>
            <ng-template nTemplate>
                <ng-container [ngTemplateOutlet]="confirmTemplate">
                </ng-container>
            </ng-template>
        </n-tab-item>
        <n-tab-item>
            <ng-template nTemplate>
                <n-batch [cmds]="cmds"
                    (onComplete)="onComplete($event)">
                </n-batch>
            </ng-template>
        </n-tab-item>
    </n-tab>

    <!-- 极简模式，由于参数分布在3个组件里，所以需要一起展示 -->
    <ng-container *ngIf="isSimpleMode">
        <div [class.hidden]="activeIndex === steps.length">
            <!-- 名称、描述 -->
            <h2 class="mb-15">{{i18n.title.basicInfo}}</h2>
            <ng-container [ngTemplateOutlet]="specifyObjTemplate">
            </ng-container>

            <!-- 极简模式，执行周期 -->
            <h2 class="mb-15">{{i18n.title.timePolicyLab}}</h2>
            <ng-container
                [ngTemplateOutlet]="configPolicySTemplate">
            </ng-container>

            <!-- 是否立即执行，这个放在确认页的 -->
            <div class="mt-20"></div>
            <ng-container [ngTemplateOutlet]="confirmTemplate">
            </ng-container>
        </div>

        <!-- 批量执行页 -->
        <n-batch *ngIf="activeIndex === steps.length" [cmds]="cmds"
            (onComplete)="onComplete($event)">
        </n-batch>
    </ng-container>

    <!-- 每一步的组件，抽取成模板，方便极简模式和标准模式引用 -->
    <ng-template #specifyObjTemplate>
        <app-hyper-cdp-schedule-create-specify-obj #specificObjDt
            id='create-cdpschedule-obj-tab'
            [type]="type"
            [vstore]="vstore">
        </app-hyper-cdp-schedule-create-specify-obj>
    </ng-template>

    <ng-template #configPolicyTemplate>
        <app-hyper-cdp-schedule-create-config-policy #configPolicyDt
            id='create-cdpschedule-policy-tab'
            [type]="type">
        </app-hyper-cdp-schedule-create-config-policy>
    </ng-template>

    <ng-template #configPolicySTemplate>
        <app-hyper-cdp-schedule-create-config-policy-s #configPolicySDt
            [type]="type">
        </app-hyper-cdp-schedule-create-config-policy-s>
    </ng-template>

    <ng-template #confirmTemplate>
        <app-hyper-cdp-schedule-create-confirm #confrimDt
            id='create-cdpschedule-confrm-tab'
            [data]="createConfig"
            [policyValue]="policyValue"
            [selectedLuns]="selectedLUN"
            [selectedPgs]="selectedPG"
            [selectedFS]="selectedFS"
            [selectedVstore]="selectedVstore"
            [type]="type">
        </app-hyper-cdp-schedule-create-confirm>
    </ng-template>

    <n-footer>
        <button pButton
            *ngIf="!isSimpleMode && activeIndex > 0 && activeIndex < steps.length"
            type="button"
            id="create_hyper_cdp_schedule_previous_btn"
            [label]="i18n.table.previousBtn"
            (click)="previous()">
        </button>
        <button pButton
            *ngIf="!isSimpleMode && activeIndex < steps.length - 1"
            class="ui-btn-primary"
            type="button"
            id="create_hyper_cdp_schedule_next_btn"
            [label]="i18n.table.nextBtn"
            (click)="next()">
        </button>
        <button pButton
            *ngIf="isSimpleMode ? (activeIndex !== steps.length) : (activeIndex === steps.length - 1)"
            id="create_hyper_cdp_schedule_confirm_btn"
            type="button"
            class="ui-btn-primary"
            [label]="i18n.table.confirmBtn"
            (click)="confrim()">
        </button>
        <button pButton *ngIf="activeIndex < steps.length"
            id="create_hyper_cdp_schedule_cancel_btn"
            type="button"
            [label]="i18n.table.cancelBtn"
            (click)="windowVisible = false;">
        </button>
        <button pButton
            *ngIf="activeIndex === steps.length"
            type="button"
            [label]="i18n.table.closeBtn"
            [disabled]="cmdExcuting"
            (click)="windowVisible = false;">
        </button>
    </n-footer>
</n-slide-window>